export default {
    ESF: 1,
    ENASF_AP: 2,
    EMAD_TIPO_I: 3,
    EAD: 4,
    EAP: 5,
    EAPP: 6,
    ECR: 7,
    EMAESM: 8,
    EMAP: 9,
    EMSI: 10,
    ESB: 11,
    EMULTI: 12,
}